export default __webpack_public_path__ + "src/images/packages/clifftop-exclusive-safari/d2d0b7796eb933ad74a6d20e77d70bf2-1.jpeg";